import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/phone.svg'


const _hoisted_1 = { class: "form-card" }
const _hoisted_2 = { class: "form-card__inner" }
const _hoisted_3 = { class: "form-card__header" }
const _hoisted_4 = { class: "form-card__title title title--secondary" }
const _hoisted_5 = { class: "form-card__subtitle" }
const _hoisted_6 = { class: "form-card__input" }
const _hoisted_7 = { class: "form-card__input" }
const _hoisted_8 = { class: "form-card__hint" }
const _hoisted_9 = { class: "form-card__btn" }
const _hoisted_10 = { class: "button__loader" }
const _hoisted_11 = {
  key: 0,
  class: "spinner"
}
const _hoisted_12 = {
  key: 1,
  class: "button__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_input_tel = _resolveComponent("ap-input-tel")!
  const _component_ap_input_money = _resolveComponent("ap-input-money")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-card__icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "phone"
          })
        ], -1)),
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t('refill.title')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('refill.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_ap_input_tel, _mergeProps({
          modelValue: _ctx.sender.phone,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sender.phone) = $event)),
          label: _ctx.t('rechargeable_number'),
          "icon-name": _ctx.icon,
          "error-text": _ctx.refillError.phone
        }, _toHandlers(!_ctx.filledPhone ? { keyup: _ctx.clearPhoneError } : {})), null, 16, ["modelValue", "label", "icon-name", "error-text"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_ap_input_money, {
          modelValue: _ctx.sender.amount,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sender.amount) = $event)),
          type: "sum",
          label: _ctx.t('amount'),
          currency: "",
          "error-text": _ctx.refillError.amount,
          onKeyup: _ctx.clearPhoneError
        }, null, 8, ["modelValue", "label", "error-text", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('refill.hint')), 1),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ap_button, {
          type: "primary",
          full: "",
          disable: _ctx.disableBtn,
          onClick: _ctx.validateSender
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.checking)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('continue')), 1))
            ])
          ]),
          _: 1
        }, 8, ["disable", "onClick"])
      ])
    ])
  ]))
}